import { Banner, DevelopmentProcess, Faq, OurCrossPlatformAppDevelopmentServices, ToolsAndFrameworks, WhatIsCrossPlatformApp, WhyChooseCrossPlatformMobileDevelopment } from "./components"

 function CrossPlatformMobileAppDevelopment(){
    

    return(
  <section className="allow-context space-y-20 md:space-y-36 mb-20 md:mb-32" >
     <Banner/>
     <WhatIsCrossPlatformApp/>
    <WhyChooseCrossPlatformMobileDevelopment/>
    <OurCrossPlatformAppDevelopmentServices/>
    <ToolsAndFrameworks/>
    <DevelopmentProcess/>
    <Faq/>
     </section>
    ) 
 }

 export default CrossPlatformMobileAppDevelopment